const height = 23;

export const customStyles: {
  [key: string]: (
    provided: React.CSSProperties,
    state: any
  ) => React.CSSProperties;
} = {
  option: (provided, state) => ({
    ...provided,
    color: "black",
    height,
    maxHeight: height,
    minHeight: height,
    lineHeight: "0.6rem",
    zIndex: 10000,
  }),
  control: (provided) => ({
    // none of react-select's styles are passed to <Control />
    ...provided,
  }),
  container: (provided) => ({
    ...provided,
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (provided) => ({ ...provided, zIndex: "9999 !important" as any }),
};
